var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agent-flow-details',{class:_vm.isFlyout ? 'gl-mx-3' : '',attrs:{"is-loading":_vm.isLoading,"status":_vm.status,"agent-flow-definition":_vm.agentFlowDefinition,"agent-flow-checkpoint":_vm.agentFlowCheckpoint,"executor-url":_vm.executorUrl,"created-at":_vm.createdAt,"project":_vm.project,"updated-at":_vm.updatedAt}})
}
var staticRenderFns = []

export { render, staticRenderFns }